import ZuckJS from "zuck.js";

let HISTORY_INNER_SPACE = 48;
let PROGRESS_OFFSET = 6;
const ARROW_OFFSET = 24;
const ARROW_WIDTH = 32;

let ajaxUrl = "/ajax/inithistoryitems";

if ($(window).width() < 767) {
  HISTORY_INNER_SPACE = 32;
  PROGRESS_OFFSET = 12;

  ajaxUrl = "/ajax/inithistoryitemsmobile";
}

$.ajax({
  method: "POST",
  url: ajaxUrl,
}).done(function (res) {
  const storiesJson = JSON.parse(res);

  // cоздает JSON-элемент для инициализации истории
  function createStoryJsonItem(story) {
    const stories = [];

    if (story.stories) {
      story.stories.forEach((el, index) => {
        stories.push([
          `${story.id}-${index}`,
          "photo",
          5,
          el.image,
          el.image,
          el.link ? el.link : "",
          el.linkText ? el.linkText : "",
          false,
          story.editedon,
        ]);
      });
    }

    return [
      story.id,
      story.logo,
      story.pagetitle,
      "",
      story.editedon,
      [...stories],
      story.order,
    ];
  }

  // оборачивает JSON  функцию Zuck.buildTimelineItem
  function initHistoryItems() {
    const tmpArr = [];
    storiesJson.forEach(function (story) {
      const storyArrItem = createStoryJsonItem(story);
      tmpArr.push(ZuckJS.buildTimelineItem(...storyArrItem));
    });
    return tmpArr;
  }

  // инициализирует размеры контейнера истории
  function initStorySize(storyId) {
    const currentStory = $("[data-story-id=" + storyId + "]");
    const itemActive = currentStory.find(".item.active");
    const media = itemActive.find(".media");

    let mediaWidth = $(media).width();

    media.on("load", function () {
      mediaWidth = $(media).width();
      recalculateValues();
    });

    function recalculateValues() {
      const mediaOffsetLeft = ($(window).width() - mediaWidth) / 2;
      const progress = $(".slides-pointers");
      const link = $(".history__link");

      const prevBtn = $(".history__arrow--prev");
      const nextBtn = $(".history__arrow--next");
      const btnPosition = mediaOffsetLeft - ARROW_WIDTH - ARROW_OFFSET;

      prevBtn.css("left", btnPosition);
      nextBtn.css("right", btnPosition);

      progress.css("width", mediaWidth - HISTORY_INNER_SPACE + PROGRESS_OFFSET);
      link.css("width", mediaWidth - HISTORY_INNER_SPACE);
    }

    recalculateValues();
  }
  var stories = new ZuckJS("stories", {
    backNative: true,
    previousTap: true,
    skin: "",
    autoFullScreen: false,
    avatars: false,
    paginationArrows: true,
    list: true,
    cubeEffect: true,
    localStorage: true,
    stories: [...initHistoryItems()],
    callbacks: {
      onOpen(storyId, callback) {
        callback();
        $("html").addClass("noscroll");

        initStorySize(storyId);
      },

      onView(storyId) {
        initStorySize(storyId);
      },

      onClose(storyId, callback) {
        callback();
        $("html").removeClass("noscroll");
      },

      onNavigateItem(storyId, nextStoryId, callback) {
        callback();

        initStorySize(storyId);
      },
    },
    template: {
      // use these functions to render custom templates
      // see src/zuck.js for more details
      timelineItem(itemData) {
        return `<div class="history__col story ${
          itemData.seen === true ? "seen" : ""
        }">
                                  <a class="history__item item-link" href="${
                                    itemData.link
                                  }">
                                    <span class="item-preview history__logo">
                                      <img width="80" height="80" lazy="eager" src="${
                                        itemData.photo
                                      }" title="${itemData.name}" alt="Логотип ${
          itemData.name
        }" />
                                    </span>
                                    <span class="info" itemProp="author" itemScope itemType="http://schema.org/Person">
                                      <span class="name" itemProp="name">${
                                        itemData.name
                                      }</span>
                                      <span class="time">${
                                        itemData.lastUpdated
                                      }</span>
                                    </span>
                                  </a>

                                  <ul class="items"></ul>
                                </div>`;
      },
      timelineStoryItem(itemData) {
        const reserved = [
          "id",
          "seen",
          "src",
          "link",
          "linkText",
          "time",
          "type",
          "length",
          "preview",
        ];
        let attributes = `
                        href="${itemData.src}"
                        data-link="${itemData.link}"
                        data-linkText="${itemData.linkText}"
                        data-time="${itemData.time}"
                        data-type="${itemData.type}"
                        data-length="${itemData.length}"
                      `;

        for (const dataKey in itemData) {
          if (reserved.indexOf(dataKey) === -1) {
            attributes += ` data-${dataKey}="${itemData[dataKey]}"`;
          }
        }

        return `<a ${attributes}>
                                <img loading="auto" title="История ${itemData.id}" alt="История ${itemData.id}" src="${itemData.preview}" />
                              </a>`;
      },
      viewerItem(storyData, currentStoryItem) {
        return `<div class="story-viewer">
                                    <div class="head history__head">
                                      <div class="right">
                                        <a class="history__close close" tabIndex="2"></a>
                                      </div>
                                    </div>
                                    <div class="slides-pointers">
                                      <div class="wrap"></div>
                                    </div>
                                    <div class="history__pagination slides-pagination">
                                      <span class="history__arrow history__arrow--prev previous"></span>
                                      <span class="history__arrow history__arrow--next next"></span>
                                    </div>
                                  </div>`;
      },
      viewerItemBody(index, currentIndex, item) {
        return `<div
                                class="item ${
                                  item.seen === true ? "seen" : ""
                                } ${currentIndex === index ? "active" : ""}"
                                data-time="${item.time}" data-type="${
          item.type
        }" data-index="${index}" data-item-id="${item.id}">
                                <img loading="auto" class="media" src="https://cdn.online-bookmakers.ru/${
                                  item.src
                                }" ${item.type} />

                                ${
                                  item.link
                                    ? `<a class="btn btn--violet history__link" href="${
                                        item.link
                                      }" rel="nofollow"  target="_blank">
                                        ${
                                          !item.linkText || item.linkText === ""
                                            ? "Перейти"
                                            : item.linkText
                                        }
                                      </a>`
                                    : ""
                                }
                              </div>`;
      },
    },
  });
});
